import { useEffect, useState } from 'react';
export var useResetImage = function useResetImage(defaultImageConfig) {
  var _useState = useState(false),
      hasBeenReset = _useState[0],
      setHasBeenReset = _useState[1];

  useEffect(function () {
    setHasBeenReset(false);
  }, [defaultImageConfig]);

  var resetImage = function resetImage(imageData, onChange) {
    if (defaultImageConfig.reset && !hasBeenReset) {
      onChange({
        imgUrl: '',
        legend: '',
        credits: ''
      });
      setHasBeenReset(true);
    }
  };

  return {
    resetImage: resetImage
  };
};